import React, {useContext, useState} from 'react';
import './Profile.scss';
import {I18nContext} from '../../contexts/i18nContext';
import {AdminContext} from '../../contexts/adminContext';
import {getCurrentUserData} from '../../helpers/helpers';
import {Button, Modal} from '../_common';
import ChangePasswordForm from "../admin/ChangePasswordForm";

const Profile = () => {
  const user = getCurrentUserData();
  const { t } = useContext(I18nContext);
  const {
    changePasswordPending,
    changePasswordByUser
  } = useContext(AdminContext);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);

  const rolesOptions = [
    {id: 'ADMIN', label: t('admin')},
    {id: 'USER', label: t('user')}
  ];

  const toggleShowChangePasswordModal = () => {
    setShowChangePasswordModal(!showChangePasswordModal);
  };

  const changePassword = async (formData) => {
    const changedPassword = await changePasswordByUser({
      email: user.email,
      newPassword: formData.newPassword,
      oldPassword: formData.currentPassword
    });
    toggleShowChangePasswordModal();
  };

  return (
    <div className='Profile'>
      <div className='header'>
        <div className='headerTitle'>{t('profile')}</div>
      </div>
      <div className='content'>
        <div className='profileItem'>
          <div className='profileItemLabel'>
            {t('first name')}
          </div>
          <div className='profileItemValue'>
            {user.firstName}
          </div>
        </div>
        <div className='profileItem'>
          <div className='profileItemLabel'>
            {t('last name')}
          </div>
          <div className='profileItemValue'>
            {user.lastName}
          </div>
        </div>
        <div className='profileItem'>
          <div className='profileItemLabel'>
            {t('e-mail')}
          </div>
          <div className='profileItemValue'>
            {user.email}
          </div>
        </div>
        <div className='profileItem'>
          <div className='profileItemLabel'>
            {t('role')}
          </div>
          <div className='profileItemValue'>
            {rolesOptions.find(role => role.id === user.role).label}
          </div>
        </div>
        <div className='profileButtons'>
          <Button type='primary' action={toggleShowChangePasswordModal} label={t('change password')} />
        </div>
      </div>

      {!!showChangePasswordModal && (
        <Modal
          closeModal={toggleShowChangePasswordModal}
          title={t('change password')}
          width='310px'
        >
          <ChangePasswordForm
            primaryButtonAction={changePassword}
            secondaryButtonAction={toggleShowChangePasswordModal}
            user
          />
        </Modal>
      )}
    </div>
  );
};

export default Profile;
